import Link from 'next/link'
import { useState, useEffect, useRef } from 'react';

export default function TabMenu({active}){
    const classes = "text-reset border-0 rounded-0 bg-transparent px-4 pb-3"
    const [isSticky, setSticky] = useState(false);
    const ref = useRef(null);
    const handleScroll = () => {
      if (ref.current) {
        setSticky(ref.current.getBoundingClientRect().top <= 0);
      }
    };
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', () => handleScroll);
      };
    }, []);
    return(
        
        <div className={`sticky-wrapper text-center position-sticky top-0 zindex-1 pt-4 ${isSticky ? ' sticky' : ''}`} ref={ref}>
            <Link href="/learn-and-earn/overview" passHref><a className={`${classes} ${active === 'overview' ? 'active' : null } button`}>Overview</a></Link>
            <Link href="/learn-and-earn/activity" passHref><a className={`${classes} ${active === 'activity' ? 'active' : null } button`}>Activity</a></Link>
            <Link href="/learn-and-earn/badges" passHref><a className={`${classes} ${active === 'badges' ? 'active' : null } button`}>Badges</a></Link>
            <Link href="/learn-and-earn/points" passHref><a className={`${classes} ${active === 'points' ? 'active' : null } button`}>Points</a></Link>
            <style jsx global>
            {`
                .button{
                    display:inline-block;
                    text-decoration: none;
                }
                .button:hover{
                    text-decoration: none;
                }
                .button.active{
                    border-bottom:2px solid #43a649!important;
                }
                .sticky-wrapper{
                    background-color: #f7f7f7;
                }
                .sticky-wrapper .button{
                    border-bottom:3px solid transparent!important;
                }
                .sticky-wrapper .button.active{
                    border-color:#43a649!important;
                } 
                .sticky {
                    box-shadow: 0 5px 5px -5px #333;
                }
                .sticky .button.active{
                    background-color: #43a649!important;
                    color: white!important;
                    padding: .25rem 1rem!important;
                    border-radius: .25rem!important;
                    margin-bottom: 1rem;
                }
            
            `}
            </style>
        </div>
       
    )
}